import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import './Textarea.scss';
import IconError from 'assets/icons/icon-error.svg';


const Textarea = ({
  label, name, value, placeholder, disabled, required, isValid, onInputChange, customClass,
  isSmall, readOnly, onFocus, errorMessage, isTranslate, intl, isSubmitClicked,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isInputTouched, setInputTouched] = useState(false);
  const inputClasses = classNames({
    'form-fieldset__input': true,
    'form-fieldset__input--disabled': disabled,
    'form-fieldset__input--error': !isValid && (isInputTouched || isSubmitClicked),
    'form-fieldset__input--small': isSmall,
  });

  const setValue = (e) => {
    const newVal = e.target.value;
    setInputValue(newVal);
    onInputChange(e);
  };

  const onInputBlur = () => {
    setInputTouched(true);
  };

  return (
    <section className="form-fieldset">
      {label && (<span className="form-fieldset__label">{isTranslate ? intl.formatMessage({ id: label }) : label}</span>)}
      <div className={inputClasses}>
        <textarea
          className={customClass}
          name={name}
          value={inputValue}
          placeholder={isTranslate ? intl.formatMessage({ id: placeholder }) : placeholder}
          disabled={disabled}
          required={required}
          onChange={setValue}
          readOnly={readOnly}
          onFocus={onFocus}
          onBlur={onInputBlur}
        >
          {/* {inputValue} */}
        </textarea>
        {!isValid && (isInputTouched || isSubmitClicked) && <img className="form-fieldset__input__icon" src={IconError} alt="error" />}
      </div>
      {!isValid && (isInputTouched || isSubmitClicked) && errorMessage && (
        <span className="notification notification--error">
          {errorMessage[0]}
        </span>
      )
      }
    </section>
  );
};

Textarea.propTypes = {
  /** Input Label */
  label: PropTypes.string,
  /** input name */
  name: PropTypes.string,
  /** input value */
  value: PropTypes.string,
  /** input placeholder */
  placeholder: PropTypes.string,
  /** input is disabled */
  disabled: PropTypes.bool,
  /** input is required */
  required: PropTypes.bool,
  /** Is there an error */
  isValid: PropTypes.bool,
  /** on input change */
  onInputChange: PropTypes.func,
  /** is input small */
  isSmall: PropTypes.bool,
  /** Addition class name */
  customClass: PropTypes.string,
  /** Is read only */
  readOnly: PropTypes.bool,
  /** Error message */
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  /** translate texts */
  isTranslate: PropTypes.bool,
};

Textarea.defaultProps = {
  label: null,
  name: '',
  value: '',
  placeholder: '',
  disabled: false,
  required: false,
  isValid: true,
  isSmall: false,
  onInputChange: () => {},
  customClass: '',
  readOnly: false,
  errorMessage: null,
  isTranslate: false,
};

export default injectIntl(Textarea);
